// extracted by mini-css-extract-plugin
export default {"track":"Carousel_track__Qdi9c","dots":"Carousel_dots__LR1iD","dot":"Carousel_dot__vvTe-","dotActive":"Carousel_dotActive__ZDzVa","arrows":"Carousel_arrows__Pkgal"};